import { render, staticRenderFns } from "./period.vue?vue&type=template&id=3b4c147e&scoped=true"
import script from "./period.vue?vue&type=script&lang=js"
export * from "./period.vue?vue&type=script&lang=js"
import style0 from "./period.vue?vue&type=style&index=0&id=3b4c147e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c147e",
  null
  
)

export default component.exports